import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/reports/expenses'
export default {
  namespaced: true,
  state: {
    dataList: [],
    grandTotal: 0,
    filterParams: {
      sdate: null,
      edate: null,
    },
    loading: false,
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    grandTotal(state) {
      return state.grandTotal
    },
    filterParams(state) {
      return state.filterParams
    },
    loading(state) {
      return state.loading
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data.data
      state.grandTotal = data.grandTotal
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
  },
  actions: {
    getReport({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}`, params)
        .then(response => {
          commit('SET_DATA_LIST', response.data)
          commit('SET_LOADING', false)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
  },
}
